import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { CommentsService } from 'src/app/services/comments/comments.service';
import { Utils } from '../../../../Models/Classes/utils';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { CommentClass } from 'src/app/Models/Classes/Publications/Comments/comment-class';
import { UploadMultimediaService } from 'src/app/services/upload/upload-multimedia.service';
import { element } from 'protractor';
import { File } from '@ionic-native/file/ngx';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { RequestService } from 'src/app/services/request/request.service';
import Swal2 from 'sweetalert2';
import { AlertController } from '@ionic/angular';
import { Howl } from 'howler';
import {Capacitor} from "@capacitor/core";
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { TextInputComponent } from 'src/app/components/common-elements/inputs/text-input/text-input.component';
@Component({
	selector: 'app-comments-modal',
	templateUrl: './comments-modal.component.html',
	styleUrls: ['./comments-modal.component.scss'],
})
export class CommentsModalComponent implements OnInit, OnDestroy {
public noLikes: boolean= false;
	public newComment: CommentClass;
	public replyingTo?: CommentClass;
	public activeTab: 'comments' | 'reviews' = 'comments';
	private commentsPaginatorIndex: number = 1;
	private reviewsPaginatorIndex: number = 1;
	@Input() reviews:boolean=false;
	@Input() Valoraciones: any;
	@Input() publicationId: number;
	@Input() publication: PublicationClass;
	@Input() CommentatorUsername: any;
	@Input() user_id: number;
	@Output() deleteMediaEmit = new EventEmitter<any>();

	@ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
	@ViewChild(TextInputComponent) composer?: TextInputComponent;

	constructor(
		private request:RequestService,
		private cameraService: CameraServiceService,
		private commentService: CommentsService,
		private utils: Utils,
		private publicationService: PublicationService,
		private modalCtrl: ModalController,
		public  uploadmedia: UploadMultimediaService,
		public formservice: FormServiceService,
		private alertController: AlertController,
		private socialNotifications: SocialInteractionNotificationService,
	) { }

	ngOnInit() {
		this.newComment = new CommentClass(this.publicationId);
		this.activeTab = this.reviews ? 'reviews' : 'comments';
		this.noLikes = this.activeTab === 'reviews';
		this.loadActiveTab(true);
	
	}
ngOnDestroy(): void {
	
}
	back() {
		this.modalCtrl.dismiss({
		  'dismissed': true
		});
	  }

	clickOnSend() {
		if (!this.IsEmptyText(this.newComment.getText())) {
			const audioFile = 'assets/sounds/send_sound.wav';
		const sound = new Howl({
		  src: [audioFile],
		  autoplay: true,
		  volume: 1.0, // Initial volume level (0.0 to 1.0)
		});
		sound.play();
			if(this.activeTab === 'comments'){
				this.postComment();
			}else{
				this.postReview();
			}
			
		}
	}

	IsEmptyText(textInput: string) {
		textInput = textInput.replace(/[\r\n\s]+/gm, "");
		if (textInput.length > 0) {
			return false;
		}
		return true;
	}

	setComment(comment: string) {
		this.newComment.setText(comment);
	}

	replyTo(comment: CommentClass): void {
		this.replyingTo = comment;
		this.newComment.parent_comment_id = comment.id;
		// Keep the native Ionic textarea free for typing. The recipient is shown
		// in the reply card and is added to the saved message below.
		this.newComment.setText('');
	}

	cancelReply(): void {
		this.replyingTo = undefined;
		this.newComment.parent_comment_id = null;
		this.newComment.setText('');
	}

	get topLevelComments(): CommentClass[] {
		return (this.publication?.commentContainer || []).filter(comment => !this.effectiveParentId(comment));
	}

	get threadedComments(): CommentClass[] {
		const comments = this.publication?.commentContainer || [];
		const children = new Map<number, CommentClass[]>();
		comments.forEach(comment => {
			const parentId = this.effectiveParentId(comment);
			if (!parentId) return;
			children.set(parentId, [...(children.get(parentId) || []), comment]);
		});
		const ordered: CommentClass[] = [];
		const visit = (comment: CommentClass, depth: number) => {
			(comment as any).replyDepth = depth;
			ordered.push(comment);
			(children.get(comment.id) || []).forEach(child => visit(child, depth + 1));
		};
		this.topLevelComments.forEach(comment => visit(comment, 0));
		return ordered;
	}

	commentDepth(comment: CommentClass): number {
		return Math.min(Number((comment as any).replyDepth || (this.isMentionReply(comment) ? 1 : 0)), 3);
	}

	parentUsername(comment: CommentClass): string | undefined {
		const parentId = this.effectiveParentId(comment);
		if (parentId) {
			return (this.publication?.commentContainer || [])
				.find(parent => parent.id === parentId)?.userProfile?.username;
		}
		return String(comment.text || '').match(/^@([a-z0-9_]+)/i)?.[1];
	}

	isMentionReply(comment: CommentClass): boolean {
		return !!this.effectiveParentId(comment) || /^@[a-z0-9_]+\b/i.test(String(comment.text || ''));
	}

	/**
	 * Prefer the persisted relationship. Older API responses may not yet include
	 * parent_comment_id; for those, pair an @username reply with the nearest
	 * preceding non-reply by that user so the conversation remains readable.
	 */
	private effectiveParentId(comment: CommentClass): number | undefined {
		if (comment.parent_comment_id) return comment.parent_comment_id;
		const comments = this.publication?.commentContainer || [];
		const currentIndex = comments.findIndex(item => item.id === comment.id);
		if (currentIndex < 0) return undefined;
		const match = String(comment.text || '').match(/^@([a-z0-9_]+)\b/i);
		if (!match && comment.userProfile?.username?.toLowerCase() === 'jarvis') {
			// API responses created before parent_comment_id was available: pair
			// Jarvis with the nearest older question that tags @jarvis.
			return comments.slice(currentIndex + 1).find(candidate =>
				/^@jarvis\b/i.test(String(candidate.text || ''))
			)?.id;
		}
		if (!match) return undefined;
		const username = match[1].toLowerCase();
		const parent = comments.slice(currentIndex + 1).find(candidate =>
			candidate.userProfile?.username?.toLowerCase() === username &&
			!/^@[a-z0-9_]+\b/i.test(String(candidate.text || ''))
		);
		return parent?.id;
	}

	changeTab(event: any) {
		const nextTab = event?.detail?.value === 'reviews' ? 'reviews' : 'comments';
		if (nextTab === this.activeTab) {
			return;
		}
		this.activeTab = nextTab;
		this.reviews = nextTab === 'reviews';
		this.noLikes = this.reviews;
		if (this.infiniteScroll) {
			this.infiniteScroll.disabled = false;
		}
		this.loadActiveTab(true);
	}

	takePhoto() {
		this.cameraService.takePhoto().then((mediaItem) => {
			this.newComment.setMultimedia(mediaItem);
		}).catch((error) => {
			console.error(error);
		});
	}

	pickMedia() {
		this.cameraService.pickMedia().then((mediaItem) => {
			this.newComment.setMultimedia(mediaItem);
		}).catch((error) => {
			console.error(error);
		});
	}

	takeVideo() {
		this.cameraService.takeVideo().then((mediaItem) => {
			this.newComment.setMultimedia(mediaItem);
		}).catch((error) => {
			console.error(error);
		});
	}

	private loadActiveTab(forceRefresh = false) {
		if (this.activeTab === 'reviews') {
			this.getReviews(forceRefresh);
			return;
		}
		this.getComments(forceRefresh);
	}

	getComments(forceRefresh = false) {
		if (forceRefresh) {
			this.commentsPaginatorIndex = 1;
			this.publication.commentContainer = [];
		}


		this.commentService.getComments(this.publicationId, 1).then((data: any) => {

			Object.keys(data.data).forEach(key => {
				let value = data.data[key];
			
				this.commentService.updateCommentList(value, this.publication).then((comment) => {

				}).catch((error) => {
					console.error(error);
				});
			});

			this.commentsPaginatorIndex = 2;


		}).catch(error => {
			console.log(error);
			if (error.error) {
				error = JSON.parse(error.error);
				if (error.error == 'the publication no longer exist') {
					this.modalCtrl.dismiss();
					this.publicationService.DeleteLocalPublicationByID(this.publication.id);
				}
			}
		});
	}
	getReviews(forceRefresh = false) {
		if (forceRefresh) {
			this.reviewsPaginatorIndex = 1;
			this.publication.ReviewContainer = [];
		}


		this.commentService.getReviews(this.publicationId, 1).then((data: any) => {

			Object.keys(data.data).forEach(key => {
				let value = data.data[key];
	
				this.commentService.updateReviewList(value, this.publication).then((comment) => {

				}).catch((error) => {
					console.error(error);
				});
			
			});

			this.reviewsPaginatorIndex = 2;


		}).catch(error => {
			console.log(error);
			if (error.error) {
				error = JSON.parse(error.error);
				if (error.error == 'the publication no longer exist') {
					this.modalCtrl.dismiss();
					this.publicationService.DeleteLocalPublicationByID(this.publication.id);
				}
			}
		});
	}

	moreData(event?) {
		const tabAtRequest = this.activeTab;
		const paginatorIndex = tabAtRequest === 'reviews' ? this.reviewsPaginatorIndex : this.commentsPaginatorIndex;
		const request = tabAtRequest === 'reviews'
			? this.commentService.getReviews(this.publicationId, paginatorIndex)
			: this.commentService.getComments(this.publicationId, paginatorIndex);

		request.then((data: any) => {
			if (tabAtRequest === 'reviews') {
				Object.keys(data.data).forEach(key => {
					let value = data.data[key];

					this.commentService.updateReviewList(value, this.publication).then((comment) => {

					}).catch((error) => {
						console.error(error);
					});
				});
			} else {
				Object.keys(data.data).forEach(key => {
					let value = data.data[key];

					this.commentService.updateCommentList(value, this.publication).then((comment) => {

					}).catch((error) => {
						console.error(error);
					});
				});
			}

			if (tabAtRequest === 'reviews') {
				this.reviewsPaginatorIndex++;
			} else {
				this.commentsPaginatorIndex++;
			}
			if (event?.target) {
				event.target.complete();
			}

			const nextPaginatorIndex = tabAtRequest === 'reviews' ? this.reviewsPaginatorIndex : this.commentsPaginatorIndex;
			if (event?.target && data.last_page < nextPaginatorIndex) {
				event.target.disabled = true;
			}
		}).catch(error => {
			console.error("Error Get Comments", error);
			if (event?.target) {
				event.target.complete();
			}
		});
	}

	public postComment() {
		let temporalComment =  this.newComment;
		const replyTarget = this.replyingTo;
		if (this.IsEmptyText(temporalComment.getText())) {
			return;
		}
		const username = replyTarget?.userProfile?.username;
		const mention = username ? `@${username}` : '';
		if (mention && !temporalComment.getText().toLowerCase().startsWith(mention.toLowerCase())) {
			temporalComment.setText(`${mention} ${temporalComment.getText().replace(/^\s+/, '')}`);
		}
		this.newComment = new CommentClass(temporalComment.publication_id);
		this.replyingTo = undefined;
		this.composer?.clear();
		this.utils.loadingPresent().then(() => {
			this.commentService.postComment(temporalComment.getDataToSend(), this.publicationId).then((data: any) => {
				if (Capacitor.getPlatform() !== 'web') {
				data = JSON.parse(data);
				}
				this.sendNotificationComment();
				if (/(^|\s)@jarvis\b/i.test(String(temporalComment.text || ''))) {
					this.request.createRequestPost('mycelium/jarvis/mention', {
						publication_id: this.publicationId,
						message: temporalComment.text,
						// Jarvis answers the new message itself, preserving a WhatsApp-style conversation.
						parent_comment_id: data.comment_id,
					}).then(() => this.getComments()).catch(error =>
						console.warn('Jarvis could not reply to this mention.', error)
					);
				}
				//console.log(data);
				let commentId = data.comment_id;
        console.log('blobs multimedia', this.commentService.blobsMultimediaComment);
				if (this.commentService.blobsMultimediaComment.length>0) {
					this.commentService.blobsMultimediaComment.forEach(element=>{
						this.uploadmedia.post(element.blob, element.filename).then((r)=>{
							const ruta = r[0];
							const mimeType = r[1];
							let pub_type = '';
							if(mimeType.includes("image")) {
							  pub_type= 'imagen';
							}else if(mimeType.includes("video")){
							  pub_type= 'video';
							}

							const objmedia = {
							  route: ruta,
							  size: 800,
							  type:pub_type,
                comment_id: data.comment_id

							};
							this.request.createRequestPost('comments.multimedia',objmedia).then(() => {
								
                this.utils.loadingDismiss();
                this.commentService.blobsMultimediaComment = [];
                this.commentService.multimediaComment = [];
                this.uploadmedia.image = '';
                 	this.updateStatusComment(this.publicationId, commentId).finally(() => {
                    this.utils.loadingDismiss().finally(() => {

                      this.commentService.getCommentFromServer(this.publication.id, commentId).then((final_data) => {
                        this.commentService.updateCommentList(final_data, this.publication);
                      }).catch((error) => {
                        console.error(error);
                      });
                    });
                  });
							}).catch((error) => {
							  this.utils.loadingDismiss();
							  Swal2.fire({
								title: 'Error al subir multimedia!',
								text: error,
								icon: 'warning',
								confirmButtonText: 'Understood',
								color: '#ffffff',
								background: '#010f4e',
								position: 'top-end',
								timerProgressBar: true,
								toast: true,
							  });

							});

						  });

					});
				}else {
					this.utils.loadingDismiss().finally(() => {
							this.commentService.updateCommentList(data.comment, this.publication);
            this.commentService.blobsMultimediaComment = [];
            this.newComment.deleteMultimedia(0);
					});
				}
			}).catch((error) => {
				console.error(error);
				this.utils.loadingDismiss();
				if(error.error){
					error = JSON.parse(error.error);
					if (error.error == 'the publication no longer exist') {
						this.modalCtrl.dismiss();
						this.publicationService.DeleteLocalPublicationByID(this.publication.id);
					}
				}
			}).finally(() => {
				//this.newComment = new CommentClass(this.publicationId);
			});
		});

	}
	public postReview() {
		let temporalComment =  this.newComment;
		this.newComment = new CommentClass(temporalComment.publication_id);
		this.utils.loadingPresent().then(() => {
			this.commentService.postReview(temporalComment.getDataToSend(), this.publicationId).then((data: any) => {
				data = JSON.parse(data);
				this.sendNotificationComment();
				//console.log(data);
				let commentId = data.comment_id;
        console.log('blobs multimedia', this.commentService.blobsMultimediaComment);
				if (this.commentService.blobsMultimediaComment.length>0) {
					this.commentService.blobsMultimediaComment.forEach(element=>{
						this.uploadmedia.post(element.blob, element.filename).then((r)=>{
							const ruta = r[0];
							const mimeType = r[1];
							let pub_type = '';
							if(mimeType.includes("image")) {
							  pub_type= 'imagen';
							}else if(mimeType.includes("video")){
							  pub_type= 'video';
							}

							const objmedia = {
							  route: ruta,
							  size: 800,
							  type:pub_type,
                comment_id: data.comment_id

							};
							this.request.createRequestPost('comments.multimedia',objmedia).then(() => {
                this.utils.loadingDismiss();
                this.commentService.blobsMultimediaComment = [];
                this.commentService.multimediaComment = [];
                this.uploadmedia.image = '';
                 	this.updateStatusComment(this.publicationId, commentId).finally(() => {
                    this.utils.loadingDismiss().finally(() => {

                      this.commentService.getCommentFromServer(this.publication.id, commentId).then((final_data) => {
                        this.commentService.updateCommentList(final_data, this.publication);
                      }).catch((error) => {
                        console.error(error);
                      });
                    });
                  });
							}).catch((error) => {
							  this.utils.loadingDismiss();
							  Swal2.fire({
								title: 'Error al subir multimedia!',
								text: error,
								icon: 'warning',
								confirmButtonText: 'Understood',
								color: '#ffffff',
								background: '#010f4e',
								position: 'top-end',
								timerProgressBar: true,
								toast: true,
							  });

							});

						  });

					});
				}else {
					this.utils.loadingDismiss().finally(() => {
				
							this.commentService.updateReviewList(data.comment, this.publication);
						
						
            this.commentService.blobsMultimediaComment = [];
            this.newComment.deleteMultimedia(0);
					});
				}
			}).catch((error) => {
				console.error(error);
				this.utils.loadingDismiss();
				if(error.error){
					error = JSON.parse(error.error);
					if (error.error == 'the publication no longer exist') {
						this.modalCtrl.dismiss();
						this.publicationService.DeleteLocalPublicationByID(this.publication.id);
					}
				}
			}).finally(() => {
				//this.newComment = new CommentClass(this.publicationId);
			});
		});

	}

	public updateStatusComment(id_publication: number, id_comment: number) {
		return new Promise((resolve, reject) => {
			let status = { status: "Activa" }
			this.commentService.putComment(status, id_publication, id_comment).then((data) => {
				resolve(data);
			}).catch((error) => {
				reject(error);
			});
		});
	}

	//public postComment(){}

	public deleteMedia(event){}
	sendNotificationComment(): Promise<void> {
		const isReview = this.activeTab === 'reviews';
		return this.socialNotifications.notifySuccessfulInteraction({
			recipientProfileId: Number(this.user_id || 0),
			notifyRemote: !this.publication?.owner,
			remoteTitle: isReview ? 'Nueva reseña en tu publicación' : 'Nuevo comentario en tu publicación',
			remoteBody: `@${this.CommentatorUsername} ${isReview ? 'publicó una reseña' : 'comentó'} en tu publicación.`,
			localTitle: isReview ? 'Reseña publicada' : 'Comentario publicado',
			localBody: isReview
				? 'Tu reseña se publicó correctamente.'
				: 'Tu comentario se publicó correctamente.',
			extra: { publication_id: this.publicationId, interaction_type: isReview ? 'review' : 'comment' },
		});
	}
	   // Function to generate an array of icon names based on value
	 getStarIcons(value: number): string[] {
		const icons: string[] = [];
		const fullStars = Math.floor(value);
		const halfStar = value - fullStars >= 0.5;
	
		for (let i = 0; i < fullStars; i++) {
		  icons.push('star');
		}
	
		if (halfStar) {
		  icons.push('star-half');
		}
	
		while (icons.length < 9) {
		  icons.push('star-outline');
		}
	
		return icons;
	  }
	  async presentStarsSelectionAlert() {
		const alert = await this.alertController.create({
		  header: 'Selecciona tu valoración',
		  inputs: [
			{
			  type: 'radio',
			  label: '1 estrella',
			  value: 1,
			},
			{
			  type: 'radio',
			  label: '2 estrellas',
			  value: 2,
			},
			{
			  type: 'radio',
			  label: '3 estrellas',
			  value: 3,
			},
			{
			  type: 'radio',
			  label: '4 estrellas',
			  value: 4,
			},
			{
			  type: 'radio',
			  label: '5 estrellas',
			  value: 5,
			},
			{
				type: 'radio',
				label: '6 estrellas',
				value: 6,
			  },
			  {
				type: 'radio',
				label: '7 estrellas',
				value: 7,
			  },
			  {
				type: 'radio',
				label: '8 estrellas',
				value: 8,
			  },
			  {
				type: 'radio',
				label: '9 estrellas',
				value: 9,
			  },
		  ],
		  buttons: [
			{
			  text: 'Cancel',
			  role: 'cancel',
			  cssClass: 'secondary',
			  handler: () => {
				console.log('Cancel clicked');
			  },
			},
			{
			  text: 'Accept',
			  handler: (selectedValue) => {
				console.log('Selected value:', selectedValue);
				this.enviarValoracion(selectedValue);
				// You can update the selected value to your component property here
				// For example: this.valoracion = selectedValue;
			  },
			},
		  ],
		});
	  
		await alert.present();
	  }


	  enviarValoracion(value){
	
   
			return new Promise((resolve, reject) => {
			  const notification = {
			value: value,
			publication_id: this.publicationId,
		
			  };
		  
			  this.request.createRequestPost('ValorarPublicaciones', notification)
				.then((data) => {
					Swal2.fire({
						title: 'Valoración enviada exitosamente',
				
						icon: 'success',
						confirmButtonText: 'OK',
						color: '#ffffff',
						background: '#010f4e',
						position: 'top-end',
						timerProgressBar: true,
						toast: true,
					  });
				  resolve(data);
				}).catch((error) => {
					Swal2.fire({
						title: 'No se pudo procesar tu valoración',
				
						icon: 'error',
						confirmButtonText: 'OK',
						color: '#ffffff',
						background: '#010f4e',
						position: 'top-end',
						timerProgressBar: true,
						toast: true,
					  });
				  console.error('Failed to send notification:', error);
				  reject(error);
				});
			});
		  
	  }
}
